/* global axios */

const agentAvailabilityReports = {
  getReports(accountId, params) {
    return axios.get(`/api/v2/accounts/${accountId}/reports/agent_availability`, { params });
  },
  downloadCSV(accountId, params) {
    return axios.get(`/api/v2/accounts/${accountId}/reports/agent_availability_download`, {
      params,
      responseType: 'blob',
    });
  },
};

export default agentAvailabilityReports;
